/**
 * https://bo.wix.com/wix-docs/rnd/platformization-guidelines/fqdn#platformization-guidelines_fqdn_fqdn-format
 */
export interface Fqdn {
  domain?: string;
  product?: string;
  version?: string;
  resource?: string;
}
